import {  Root, Message, Icon, Phrase  } from 'file:///root/project/node_modules/.cache/react-style-loader/routes_Builder_CheckerMessages_CheckerMessages-1MQs.styl';
import type { Key, ReactNode } from 'react';
import { getFlagInfo } from '../../../utils/flags';

interface FormattedNode {
    type: string;
    value: string | FormattedNode[];
}

interface Flag {
    type: string;
    message?: string;
    formattedMessage?: FormattedNode;
}

interface CheckerMessagesProps {
    data?: Flag[] | null;
}

const CheckerMessages = ({ data }: CheckerMessagesProps) =>
    <Root>
        {!data || !data.length ? <div>no messages</div> :
            data.map((flag, index) =>
                <Message
                    key={index}
                    data-type={flag.type}
                >
                    <Icon style={{ backgroundColor: getFlagInfo(flag.type).color }} />
                    {renderMessage(flag, getFlagInfo(flag.type).color)}
                </Message>,
            )
        }
    </Root>;

export default CheckerMessages;

const renderMessage = ({ message, formattedMessage }: Flag, color: string): ReactNode => {
    if (!formattedMessage) return message;

    const prettyPrint = (node: FormattedNode, props?: { key?: Key }): ReactNode =>
        <Phrase
            {...props}
            data-type={node.type}
            style={node.type === 'bold' ? { color } : undefined}
        >
            {Array.isArray(node.value)
                ? node.value.map((child, key) => prettyPrint(child, { key }))
                : node.value
            }
        </Phrase>;

    return prettyPrint(formattedMessage);
};

